import { render } from "./LanguagePicker.vue?vue&type=template&id=1c3d27cc&ts=true"
import script from "./LanguagePicker.vue?vue&type=script&lang=ts"
export * from "./LanguagePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__